"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jobList = jobList;
exports.jobLogList = jobLogList;
exports.scheduleJobAdd = scheduleJobAdd;
exports.scheduleJobDelete = scheduleJobDelete;
exports.scheduleJobStart = scheduleJobStart;
exports.scheduleJobSuspend = scheduleJobSuspend;
exports.scheduleJobTrig = scheduleJobTrig;
exports.scheduleJobUpdate = scheduleJobUpdate;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// 定时任务列表
function jobList() {
  return (0, _request.default)({
    url: '/admin/schedule/job/list',
    method: 'get'
  });
}

// 定时任务日志分页列表
function jobLogList(data) {
  return (0, _request.default)({
    url: '/admin/schedule/job/log/list',
    method: 'get',
    params: _objectSpread({}, data)
  });
}

// 添加定时任务
function scheduleJobAdd(pram) {
  var data = {
    jobId: pram.jobId,
    beanName: pram.beanName,
    cronExpression: pram.cronExpression,
    methodName: pram.methodName,
    params: pram.params,
    remark: pram.remark
  };
  return (0, _request.default)({
    url: '/admin/schedule/job/add',
    method: 'post',
    data: data
  });
}

// 删除定时任务
function scheduleJobDelete(id) {
  return (0, _request.default)({
    url: "/admin/schedule/job/delete/".concat(id),
    method: 'post'
  });
}

// 启动定时任务
function scheduleJobStart(id) {
  return (0, _request.default)({
    url: "/admin/schedule/job/start/".concat(id),
    method: 'post'
  });
}

// 暂停定时任务
function scheduleJobSuspend(id) {
  return (0, _request.default)({
    url: "/admin/schedule/job/suspend/".concat(id),
    method: 'post'
  });
}

// 立即执行定时任务（一次）暂停定时任务
function scheduleJobTrig(id) {
  return (0, _request.default)({
    url: "/admin/schedule/job/trig/".concat(id),
    method: 'post'
  });
}

// 定时任务编辑
function scheduleJobUpdate(pram) {
  var data = {
    jobId: pram.jobId,
    beanName: pram.beanName,
    cronExpression: pram.cronExpression,
    methodName: pram.methodName,
    params: pram.params,
    remark: pram.remark
  };
  return (0, _request.default)({
    url: '/admin/schedule/job/update',
    method: 'post',
    data: _objectSpread({}, data)
  });
}